import _util from '../../utils/';


const ApprovalWorkflowService = {
	selectApprovalWorkflow(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalFlowBasis/Get',
			params: data,
			success: resolve,
			error: reject
		})
	},
	deleteApprovalWorkflow(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalFlowBasis/BatchDelete',
			method: "delete",
			data: data,
			success: resolve,
			error: reject
		})
	},
	updateApprovalWorkflow(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalFlowBasis/Put',
			method: "put",
			data: data,
			success: resolve,
			error: reject
		})
	},
	createApprovalWorkflow(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalFlowBasis/Post',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
	initiaApprovalWorkflow(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalFlowBasis/Init',
			params: data,
			success: resolve,
			error: reject
		})
	},
	detailApprovalWorkflow(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalFlowBasis/Details',
			params: data,
			success: resolve,
			error: reject
		})
	}
};


export default ApprovalWorkflowService;




// WEBPACK FOOTER //
// ./src/services/Approval/approval-workflow-service.js